import { render, staticRenderFns } from "./DamageJaba.vue?vue&type=template&id=9ad71af4"
import script from "./DamageJaba.vue?vue&type=script&lang=js"
export * from "./DamageJaba.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports